var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUThermDevice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22",
    "data-name": "Group 22",
    xmlns: "http://www.w3.org/2000/svg",
    width: 94.823,
    height: 47.706,
    viewBox: "0 0 94.823 47.706",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M1.246-2.171c.382,0,.4-.548.719,2.1s.552,8.506.552,8.506v20.6A1.469,1.469,0,0,1,1,30.433c-.553,0-1-.809-1-1.807V8.44S.126,2.586.437-.067.864-2.171,1.246-2.171Z",
    transform: "translate(5.859 2.218)",
    fill: "#868686"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "rect43",
    width: 94.824,
    height: 34.896,
    rx: 4.806,
    transform: "translate(0 12.81)",
    fill: "#efefef"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_235",
    "data-name": "Rectangle 235",
    width: 88.525,
    height: 28.906,
    rx: 4,
    transform: "translate(2.221 15.789)",
    fill: "#fafafa"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "rect471",
    width: 6.703,
    height: 7.03,
    rx: 1.44,
    transform: "translate(16.643 18.11)",
    fill: "#9f9f9f"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "rect471-2",
    width: 0.692,
    height: 4.119,
    rx: 0.346,
    transform: "translate(8.376 19.506)",
    fill: "#9f9f9f"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "rect471-2-4",
    width: 0.692,
    height: 4.119,
    rx: 0.346,
    transform: "translate(9.705 19.506)",
    fill: "#9f9f9f"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "rect471-2-4-5",
    width: 0.692,
    height: 4.119,
    rx: 0.346,
    transform: "translate(11.01 19.625)",
    fill: "#9f9f9f"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "rect471-2-4-5-7",
    width: 0.692,
    height: 4.119,
    rx: 0.346,
    transform: "translate(12.256 19.625)",
    fill: "#9f9f9f"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "rect471-0",
    width: 6.703,
    height: 7.03,
    rx: 1.44,
    transform: "translate(72.079 18.49)",
    fill: "#9f9f9f"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "rect471-8",
    width: 33.567,
    height: 7.03,
    rx: 3.515,
    transform: "translate(30.651 18.49)",
    fill: "#9f9f9f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUThermDevice);
export default __webpack_public_path__ + "static/media/uTherm-device.8d5f4adf525f8438093df51bb68881f4.svg";
export { ForwardRef as ReactComponent };